import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { REFERENCIALS_URL, useGetReferentialsAsync } from '@/features/shared/apis';

import { GetCompanyTypeReferential } from '../types';

export const useCompanyTypesOptions = () => {
  const { t } = useTranslation('borderCrossingRORO_onBoarding');

  const { data: companyTypesData, isLoading: isGetCompanyTypesLoading } =
    useGetReferentialsAsync<GetCompanyTypeReferential>(REFERENCIALS_URL.COMPANY_TYPE);

  const companyTypeOptions = useMemo(
    () =>
      (companyTypesData?.companyTypes ?? []).map(({ id, translationKey }) => ({
        label: t(`borderCrossingRORO.onBoarding.subscribeAdditionnalInformation.companyType.${translationKey}`),
        value: id,
      })),
    [companyTypesData?.companyTypes, t],
  );

  return {
    isGetCompanyTypesLoading,
    companyTypeOptions,
  };
};
